$(document).ready(function() {

  $(document).on("click",".text--faq",function(){
    var dataid = $(this).attr("data-linked-id");
    console.log(dataid)
    $("html,body").animate({scrollTop:$(dataid).offset().top},"slow")
  });
  $("#shopify-section-announcement-bar").delay(4000).css('opacity','1');

  $('.image-text-slide').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 1500,
    arrows: true,
    dots: false,
    pauseOnHover: false,
  });

  const logoslider = $(".image-text-slide");

  logoslider.on('wheel', (function(e) {

    var slideCount = $(this)[0].slick["slideCount"];
    var currentIndex = $(this).slick("slickCurrentSlide");
    var totalSildeToShow =  $(this)[0].slick.options["slidesToShow"];

    if (e.originalEvent.deltaY < 0) {

      e.preventDefault();
      $(this).slick('slickPrev');

    } else {
      if (slideCount - totalSildeToShow === currentIndex)
        return;
      //e.preventDefault();
      $(this).slick('slickNext')
    }
  }));



  if($(window).width() < 749){
    $(document).on("click",".menu h3",function(){
      $(this).closest('.menu').find('.sidebar-lists').slideToggle();
      $(this).toggleClass('active');
    });
  }

  $(document).on('mouseenter', '.megemenu_custom', function() {
    var curr = $(this).attr('data-dropdown-rel');
    $(this).find('details').attr('open','open');
    $(this).find('.mainMenu__submenu_new').html($('.mega-menu[data-dropdown="' + curr + '"]').html()); 

  });
  $(document).on('mouseleave', '.megemenu_custom', function() {
    $('.mega-menu').hide();
    $(this).find('details').removeAttr('open');
    setTimeout(function(){  $('.headcontainer').removeClass('noposition'); }, 700);
  });

  $('.mega-menu-section').each(function() {
    $('.list-menu li[data-dropdown-rel="' + $( this ).find('.mega-menu').attr( "data-dropdown" ) + '"]').attr('class','megemenu_custom')
  });
  $(document).on('click','.product__media-item_thumb',function(){
    $('.product__media-item_thumb').removeClass('active');
    $(this).addClass('active');
    var slideScrollPosition = $(this).attr('data-image-link');
    $('.product__media-list').prepend($('.product__media-list li[data-image-order="'+slideScrollPosition+'"]:last'));
    $(this).closest('.productpage').find('ul.product__media-list').scrollLeft(0);
  });

  var activeleft = $('.product__media-list li:first-child').attr('data-image-order');
  $('.product__media-item_thumb[data-image-link="'+activeleft+'"]').addClass('active');

  $(document).on("change","#age-verify select",function() {
    var day = $("#day").val(),
        month = $("#month").val(),
        year = $("#year").val(),
        age = 18,
        yeardrop = $(this).attr('id');
    $('#final').val(day+'-'+month+'-'+year);
    if(yeardrop == 'year'){      
      var mydate = new Date();
      mydate.setFullYear(year, month - 1, day);
      var currdate = new Date();
      currdate.setFullYear(currdate.getFullYear() - age);
      if ((currdate - mydate) < 0) {
        $('.cartbuttons').addClass('btn_disabled');
        return false;
      }
      $('.cartbuttons').removeClass('btn_disabled');
      return true
    }
  });
  var headerht = $("#shopify-section-header .header-overlay-true").outerHeight()
  $('#MainContent').css('padding-top',headerht);
  console.log('hiddenpage');
  $('.member_no.page-retail').find('main#MainContent').fadeIn();
  $('.member_no.page-retail').find('main#MainContent').html('<div class="page-width page-margin center"><h1 class="title">Only for <span>RETAILER</span> customers</h1><a class="link" href="/account/register">Create an account</a></div>');});